var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg1122",
    viewBox: "0 0 10.356914 10.40247",
    height: "10.40247mm",
    width: "10.356915mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1116"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100.65488,-142.96543)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1015",
    style: {
      color: "#000000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      shapeMargin: 0,
      inlineSize: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "#003da5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.588579,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 105.80998,142.96585 c -2.64157,0 -4.82082,1.97835 -5.1511,4.53099 a 0.29551545,0.29551545 0 0 0 -0.004,0.0501 0.29551545,0.29551545 0 0 0 0.29559,0.29559 0.29551545,0.29551545 0 0 0 0.29404,-0.26924 h 5.1e-4 c 0.29154,-2.2686 2.21607,-4.01939 4.5651,-4.01939 2.55124,0 4.61367,2.06192 4.61367,4.61316 0,2.55124 -2.06243,4.61315 -4.61367,4.61315 -2.21697,0 -4.05567,-1.55987 -4.50102,-3.64215 h 1.77199 v -5.3e-4 h 1.75855 v 2.72283 a 0.31947993,0.31947993 0 0 0 0.31833,0.31833 h 1.30483 a 0.31947993,0.31947993 0 0 0 0.31832,-0.31832 v -2.72283 h 2.72232 a 0.31947993,0.31947993 0 0 0 0.32039,-0.31833 v -1.30431 a 0.31947993,0.31947993 0 0 0 -0.32039,-0.31833 h -2.72232 v -2.72283 a 0.31947993,0.31947993 0 0 0 -0.31832,-0.31832 h -1.30483 a 0.31947993,0.31947993 0 0 0 -0.31833,0.31832 v 2.72283 h -2.71973 v 5.3e-4 a 0.32039986,0.32039986 0 0 0 -0.31471,0.32039 0.32039986,0.32039986 0 0 0 0.32039,0.3204 0.32039986,0.32039986 0 0 0 0.0377,-0.003 h 0.27388 0.863 1.85777 a 0.31947993,0.31947993 0 0 0 0.32039,-0.32039 v -2.72077 h 0.66404 v 2.72076 a 0.31947993,0.31947993 0 0 0 0.3204,0.32039 h 2.72076 v 0.66404 h -2.72076 a 0.31947993,0.31947993 0 0 0 -0.3204,0.31988 v 2.72077 h -0.66404 v -2.72077 a 0.31947993,0.31947993 0 0 0 -0.32039,-0.31988 h -2.07688 v -5e-4 h -0.64389 v -5.3e-4 h -0.64079 v 5.3e-4 h -0.58291 c -1e-5,-1.7e-4 2e-5,-3.5e-4 0,-5.3e-4 h -0.26355 a 0.29189807,0.29189807 0 0 0 -0.002,0 0.29189807,0.29189807 0 0 0 -0.29198,0.29197 0.29189807,0.29189807 0 0 0 0.004,0.0424 h -0.001 c 0.32824,2.55488 2.50846,4.53564 5.15162,4.53564 2.86933,0 5.20123,-2.3319 5.20123,-5.20123 0,-2.86933 -2.3319,-5.20124 -5.20123,-5.20124 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedical);
export default __webpack_public_path__ + "static/media/Icon-medical.0cb506c62e41f64fc0099c1e304fc9bd.svg";
export { ForwardRef as ReactComponent };